export const KnowledgeFileStatus = {
  Pending: 0,
  Uploading: 1,
  Processing: 2,
  Ready: 3,
  Failed: 4,
  Deleted: 5,
} as const;

export type KnowledgeFileStatus = (typeof KnowledgeFileStatus)[keyof typeof KnowledgeFileStatus];

export const KnowledgeFileStatusLabel: Record<KnowledgeFileStatus, string> = {
  [KnowledgeFileStatus.Pending]: 'Pending',
  [KnowledgeFileStatus.Uploading]: 'Uploading',
  [KnowledgeFileStatus.Processing]: 'Processing',
  [KnowledgeFileStatus.Ready]: 'Ready',
  [KnowledgeFileStatus.Failed]: 'Failed',
  [KnowledgeFileStatus.Deleted]: 'Deleted',
};

export interface AgentKnowledgeFileDto {
  id: string;
  agentDefinitionId: string;
  fileName: string;
  originalFileName: string;
  contentType: string;
  fileSizeBytes: number;
  status: KnowledgeFileStatus;
  providerName?: string | null;
  lastAccessedAt?: string | null;
  uploadedToProviderAt?: string | null;
  syncError?: string | null;
  createdAt: string;
}
